import apiClient from './client';

export const autoRewardRulesApi = {
  list: () => apiClient.get('/guardians/auto_reward_rules'),
  create: (data) =>
    apiClient.post('/guardians/auto_reward_rules', { auto_reward_rule: data }),
  update: (id, data) =>
    apiClient.patch(`/guardians/auto_reward_rules/${id}`, { auto_reward_rule: data }),
  remove: (id) => apiClient.delete(`/guardians/auto_reward_rules/${id}`)
};

export default autoRewardRulesApi;
